module.exports = __webpack_public_path__ + "static/media/GDC-App-data-portal-blue.8f6a664c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/packages/@ncigdc/theme/images/GDC-App-data-portal-blue.svg
// module id = 1413
// module chunks = 31